import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// ========================
// LEADS
// ========================

export const createLead = async (leadData) => {
  const response = await api.post('/leads', leadData);
  return response.data;
};

export const getLeads = async () => {
  const response = await api.get('/leads');
  return response.data;
};

export const getLead = async (id) => {
  const response = await api.get(`/leads/${id}`);
  return response.data;
};

export const updateLeadScore = async (id, score, endType) => {
  const response = await api.patch(`/leads/${id}`, { score, end_type: endType });
  return response.data;
};

export const deleteLead = async (id) => {
  const response = await api.delete(`/leads/${id}`);
  return response.data;
};

export const exportLeadsCSV = () => {
  window.location.href = `${API}/leads/export/excel`;
};

// ========================
// SCORES
// ========================

export const createScore = async (scoreData) => {
  const response = await api.post('/scores', scoreData);
  return response.data;
};

export const getScores = async (limit = 10) => {
  const response = await api.get(`/scores?limit=${limit}`);
  return response.data;
};

export const getTop5Scores = async () => {
  const response = await api.get('/scores/top5');
  return response.data;
};

export const deleteScore = async (id) => {
  const response = await api.delete(`/scores/${id}`);
  return response.data;
};

export const resetScores = async () => {
  const response = await api.delete('/scores');
  return response.data;
};

// ========================
// SETTINGS
// ========================

export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

export const updateSettings = async (settings) => {
  const response = await api.put('/settings', settings);
  return response.data;
};

export const uploadBanner = async (lang, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/settings/banner/${lang}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const uploadEmailImage = async (position, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/settings/email-image/${position}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const sendGameEmail = async (leadId, score, endType, language) => {
  const response = await api.post('/send-game-email', {
    lead_id: leadId,
    score,
    end_type: endType,
    language,
  });
  return response.data;
};

export const verifyAdminPin = async (pin) => {
  const formData = new FormData();
  formData.append('pin', pin);
  const response = await api.post('/admin/verify-pin', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// ========================
// ASSETS
// ========================

export const getAssets = async () => {
  const response = await api.get('/assets');
  return response.data;
};

export const getAsset = async (id) => {
  const response = await api.get(`/assets/${id}`);
  return response.data;
};

export const uploadAsset = async (id, file, name) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name);
  const response = await api.post(`/assets/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteAsset = async (id) => {
  const response = await api.delete(`/assets/${id}`);
  return response.data;
};

// ========================
// RESET
// ========================

export const resetFair = async (confirmation) => {
  const formData = new FormData();
  formData.append('confirmation', confirmation);
  const response = await api.post('/admin/reset-fair', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// ========================
// LAYOUTS
// ========================

export const getLayouts = async () => {
  const response = await api.get('/layouts');
  return response.data;
};

export const getLayout = async (templateId) => {
  const response = await api.get(`/layouts/${templateId}`);
  return response.data;
};

export const saveLayout = async (templateId, placements, grid = null) => {
  const body = { placements };
  if (grid) body.grid = grid;
  const response = await api.put(`/layouts/${templateId}`, body);
  return response.data;
};

export const deleteLayout = async (templateId) => {
  const response = await api.delete(`/layouts/${templateId}`);
  return response.data;
};

// ========================
// CUSTOM EDITOR ASSETS
// ========================

export const getEditorAssets = async () => {
  const response = await api.get('/editor-assets');
  return response.data;
};

export const uploadEditorAsset = async (file, name, tw, th, assetType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name);
  formData.append('tw', tw);
  formData.append('th', th);
  formData.append('asset_type', assetType);
  const response = await api.post('/editor-assets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteEditorAsset = async (assetId) => {
  const response = await api.delete(`/editor-assets/${assetId}`);
  return response.data;
};

// ========================
// GAME SPRITES
// ========================

export const getGameSprites = async () => {
  const response = await api.get('/game-sprites');
  return response.data;
};

export const getCustomSpriteKeys = async () => {
  const response = await api.get('/game-sprites-custom-keys');
  return response.data;
};

export const uploadGameSprite = async (spriteKey, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/game-sprites/${spriteKey}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const resetGameSprite = async (spriteKey) => {
  const response = await api.delete(`/game-sprites/${spriteKey}`);
  return response.data;
};

// ========================
// HEALTH CHECK
// ========================

export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

export default api;
